<template>
  <div>
    <!-- 房产信息 -->
    <HouseProperty :readOnly="readOnly" />

    <!-- 土地信息 -->
    <LandProperty  :readOnly="readOnly" />

    <!-- 车辆信息 -->
    <CarProperty  :readOnly="readOnly" />
  </div>
</template>

<script>
import HouseProperty from "./components/houseProperty.vue";
import LandProperty from "./components/landProperty.vue";
import CarProperty from "./components/carProperty.vue";

export default {
  name: "assets",
  components: {
    HouseProperty,
    LandProperty,
    CarProperty,
  },
  data() {
    return {};
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // btnClick() {
    //   this.$emit("fatherEvent", "foodNews");
    // },
  },
};
</script>
<style scoped lang="scss">
</style>

